import classNames from 'classnames';
import { take, map, values, get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Button, { TYPES } from 'components/Button';
import { mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

export { TYPES };

const SECTION_WIDTH = 384;

const CTALinks = ({ links, onClick, type, className }) => (
  <div
    className={classNames(
      'CTALinks',
      { 'CTALinks--single': get(links, 'length') === 1 },
      className
    )}
  >
    {map(take(links, 2), ({ linkUrl, label, openInNewWindow }, index) => (
      <Button
        key={index}
        type={type}
        linkTo={linkUrl}
        onClick={() => onClick(linkUrl, label)}
        target={openInNewWindow ? '_blank' : null}
      >
        {label}
      </Button>
    ))}
    <style jsx>
      {`
        .CTALinks {
          display: flex;
          margin-top: ${Theme.get('spacing') * 4}px;
          width: ${SECTION_WIDTH}px;
          max-width: 100%;
          flex-wrap: wrap;
          gap: ${Theme.get('spacing') * 2}px;
          justify-content: center;
        }

        @media ${mediumUp} {
          .CTALinks {
            flex-wrap: nowrap;
            gap: 0;
          }
        }
      `}
    </style>
    <style jsx global>
      {`
        .CTALinks .Button {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          line-height: normal;
          white-space: nowrap;
          max-width: min(100%, calc((${SECTION_WIDTH}px - ${Theme.get('spacing')}px) / 2.5));
          margin: 0;
        }

        .CTALinks--single .Button {
          white-space: normal;
          max-width: 100%;
        }

        @media ${mediumUp} {
          .CTALinks .Button {
            max-width: none;
          }

          .CTALinks .Button:nth-child(2) {
            margin-left: ${Theme.get('spacing') * 4}px;
          }
        }
      `}
    </style>
  </div>
);

CTALinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      linkUrl: PropTypes.string,
      openInNewWindow: PropTypes.bool,
    })
  ).isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(values(TYPES)),
  className: PropTypes.string,
};

CTALinks.defaultProps = {
  onClick: () => {},
  type: TYPES.DEFAULT,
  className: '',
};

export default CTALinks;
